/**
 * **Control** (Core p.268, 6-round cap) — the ONE path-dependent sitrep. RAW: at the
 * end of EACH round, a side gains 1pt per CZ it controls (+1 bonus for holding all
 * four); highest accumulated score at the end of round 6 wins, a tie is a **draw**
 * (both sides withdraw). That per-round accumulation lives in `sitrepProgress.scores`
 * (`SitrepProgress`, seeded `{pc:0,npc:0}` by `set_sitrep`), written by
 * `controlScoreDelta` + the `end_round` embed. **This predicate only READS
 * `sitrepProgress.scores`** and compares at the round-6 boundary; it never derives a
 * score from zone occupancy itself, which would duplicate that accumulation rather
 * than read it.
 */
import type { EncounterState, SitrepConfig } from "@lancer-vtt/domain";
import type { SitrepStatus } from "../status";
import { roundLimitReached, roundsRemainingFor } from "../roundBoundary";

export function controlStatus(state: EncounterState, sitrep: SitrepConfig): SitrepStatus {
  const scores = state.sitrepProgress?.scores ?? { pc: 0, npc: 0 };
  if (!roundLimitReached(state, sitrep.roundLimit)) {
    return { phase: "active", scores, roundsRemaining: roundsRemainingFor(state, sitrep.roundLimit) };
  }
  const winner = scores.pc === scores.npc ? "draw" : scores.pc > scores.npc ? "pc" : "npc";
  return { phase: "decided", winner, scores };
}
